import { useCallback } from 'react';
import { useConversation } from '@/app/providers/ConversationContext';
import { useToast } from '@/app/providers/ToastContext';
import { recordChatCreation, getRecentChatCount, pickNewChatName } from '@/lib/greetings';

export function useHandleCreateConversation() {
  const { allConversations, createConversation } = useConversation();
  const { showToast } = useToast();

  return useCallback(() => {
    if (getRecentChatCount() >= 2) {
      showToast('Slow down — too many new chats. Try using your current one.', 'warning' as any);
      return;
    }
    recordChatCreation();
    const existingNames = new Set(allConversations.map((c) => (c.name || '').trim().toLowerCase()));
    const conversationName = pickNewChatName(existingNames);
    // New conversations start in chat-only mode. Even if the current
    // conversation has modules open, the new chat should not inherit them.
    // Only `name` and `icon` are forwarded to the create mutation; the API
    // assigns id/timestamps/version on insert (#2448).
    createConversation(
      {
        id: `conversation-${Date.now()}`,
        name: conversationName,
        icon: '📁',
        modules: [],
      },
      { preserveModuleId: null },
    );
  }, [allConversations, createConversation, showToast]);
}
